"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconForContentType = exports.IconType = exports.LineageItemType = void 0;
const catalog_icons_1 = require("@tableau/catalog-icons");
var LineageItemType;
(function (LineageItemType) {
    LineageItemType["Dashboard"] = "dashboard";
    LineageItemType["Database"] = "database";
    LineageItemType["Datasource"] = "datasource";
    LineageItemType["Flow"] = "flow";
    LineageItemType["Lens"] = "lens";
    LineageItemType["Metric"] = "metric";
    LineageItemType["Sheet"] = "sheet";
    LineageItemType["Table"] = "table";
    LineageItemType["User"] = "user";
    LineageItemType["VirtualConnection"] = "virtualConnection";
    LineageItemType["VirtualConnectionTable"] = "virtualConnectionTable";
    LineageItemType["Workbook"] = "workbook";
    LineageItemType["MetricDefinition"] = "metricDefinition";
})(LineageItemType = exports.LineageItemType || (exports.LineageItemType = {}));
var IconType;
(function (IconType) {
    IconType["inactive"] = "inactive";
    IconType["active"] = "active";
    IconType["white"] = "white";
})(IconType = exports.IconType || (exports.IconType = {}));
const activeIcons = {
    dashboard: catalog_icons_1.SvgDataCatalogLineageDashboardActive,
    database: catalog_icons_1.SvgDataCatalogLineageServerActive,
    datasource: catalog_icons_1.SvgDataCatalogLineageDsActive,
    flow: catalog_icons_1.SvgDataCatalogLineageFlowActive,
    lens: catalog_icons_1.SvgDataCatalogLineageLensActive,
    metric: catalog_icons_1.SvgDataCatalogLineageMetricActive,
    sheet: catalog_icons_1.SvgDataCatalogLineageSheetActive,
    table: catalog_icons_1.SvgDataCatalogLineageTableActive,
    user: catalog_icons_1.SvgDataCatalogLineageUsersActive,
    virtualConnection: catalog_icons_1.SvgDataCatalogLineageVirtualConnectionActive,
    virtualConnectionTable: catalog_icons_1.SvgDataCatalogLineageVirtualConnectionTableActive,
    workbook: catalog_icons_1.SvgDataCatalogLineageWorkbookActive,
    metricDefinition: catalog_icons_1.SvgDataCatalogMetricDefinitionActive,
};
const inactiveIcons = {
    dashboard: catalog_icons_1.SvgDataCatalogLineageDashboard,
    database: catalog_icons_1.SvgDataCatalogLineageServer,
    datasource: catalog_icons_1.SvgDataCatalogLineageDs,
    flow: catalog_icons_1.SvgDataCatalogLineageFlow,
    lens: catalog_icons_1.SvgDataCatalogLineageLens,
    metric: catalog_icons_1.SvgDataCatalogLineageMetric,
    sheet: catalog_icons_1.SvgDataCatalogLineageSheet,
    table: catalog_icons_1.SvgDataCatalogLineageTable,
    user: catalog_icons_1.SvgDataCatalogLineageUsers,
    virtualConnection: catalog_icons_1.SvgDataCatalogLineageVirtualConnection,
    virtualConnectionTable: catalog_icons_1.SvgDataCatalogLineageVirtualConnectionTable,
    workbook: catalog_icons_1.SvgDataCatalogLineageWorkbook,
    metricDefinition: catalog_icons_1.SvgDataCatalogMetricDefinition,
};
const whiteIcons = {
    dashboard: catalog_icons_1.SvgDataCatalogLineageDashboardWhite,
    database: catalog_icons_1.SvgDataCatalogLineageServerWhite,
    datasource: catalog_icons_1.SvgDataCatalogLineageDsWhite,
    flow: catalog_icons_1.SvgDataCatalogLineageFlowWhite,
    lens: catalog_icons_1.SvgDataCatalogLineageLensWhite,
    metric: catalog_icons_1.SvgDataCatalogLineageMetricWhite,
    sheet: catalog_icons_1.SvgDataCatalogLineageSheetWhite,
    table: catalog_icons_1.SvgDataCatalogLineageTableWhite,
    user: catalog_icons_1.SvgDataCatalogLineageUsersWhite,
    virtualConnection: catalog_icons_1.SvgDataCatalogLineageVirtualConnectionWhite,
    virtualConnectionTable: catalog_icons_1.SvgDataCatalogLineageVirtualConnectionTableWhite,
    workbook: catalog_icons_1.SvgDataCatalogLineageWorkbookWhite,
    metricDefinition: catalog_icons_1.SvgDataCatalogMetricDefinitionWhite,
};
function getIconForContentType(contentType, iconType) {
    const iconDirectory = iconType === IconType.active
        ? activeIcons
        : iconType === IconType.white
            ? whiteIcons
            : inactiveIcons;
    return iconDirectory[contentType] || catalog_icons_1.SvgSchemaViewerBlank;
}
exports.getIconForContentType = getIconForContentType;
//# sourceMappingURL=LineageItemType.js.map